export const getBaseUrlForBrukerAdmin = function (): string {
  if (process.env.VUE_APP_ENVIRONMENT !== 'production') {
    return 'https://test.byggesoknaden.no/brukeradministrasjon/Admin';
  } else {
    return 'https://www.byggesoknaden.no/brukeradministrasjon/Admin';
  }
};
